import { render, staticRenderFns } from "./ShareItem.vue?vue&type=template&id=5d82eb8f&scoped=true&"
import script from "./ShareItem.vue?vue&type=script&lang=ts&"
export * from "./ShareItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShareItem.vue?vue&type=style&index=0&id=5d82eb8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82eb8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VIcon,VSnackbar})
